import { all, call, put, takeLatest } from "redux-saga/effects";
import * as api from "../../../utils/api";
import { API_URL } from "../../../utils/axios";
import {
  getBoosterPlanMinAmountFailed,
  getBoosterPlanMinAmountSuccess,
  getAdvancePlanMinAmountFailed,
  getAdvancePlanMinAmountSuccess,
  getMixedFundsFailed,
  getMixedFundsSuccess,
  getEquityFundsFailed,
  getEquityFundsSuccess,
  getImmfFundFailed,
  getImmfFundSuccess
} from "./actions";
import * as constant from "./constant";

export function* getBoosterPlanMinAmountSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/min_amount_booster`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getBoosterPlanMinAmountSuccess(data));
  } catch (error) {
    yield put(getBoosterPlanMinAmountFailed());
  }
}

export function* getAdvancePlanMinAmountSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/min_amount_advance`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getAdvancePlanMinAmountSuccess(data));
  } catch (error) {
    yield put(getAdvancePlanMinAmountFailed());
  }
}

export function* getMixedFundsSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/mixed_funds`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getMixedFundsSuccess(data));
  } catch (error) {
    yield put(getMixedFundsFailed());
  }
}

export function* getEquityFundsSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/equity_funds`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getEquityFundsSuccess(data));
  } catch (error) {
    yield put(getEquityFundsFailed());
  }
}

export function* getImmfFundSaga() {
  try {
    const res = yield call(
      api.get,
      `${API_URL.mp}/smp/sys-config/immf_fund`
    );
    if (!Object.keys(res.data).length) {
      throw new Error("Something wrong!");
    }
    if (res.data === "Not Found") {
      throw new Error("Something wrong!");
    }

    const { data } = res;

    yield put(getImmfFundSuccess(data));
  } catch (error) {
    yield put(getImmfFundFailed());
  }
}

export function* planWorkerSaga() {
  yield all([
    takeLatest(constant.GET_BOOSTER_PLAN_MIN_AMOUNT, getBoosterPlanMinAmountSaga),
    takeLatest(constant.GET_ADVANCE_PLAN_MIN_AMOUNT, getAdvancePlanMinAmountSaga),
    takeLatest(constant.GET_EQUITY_FUNDS, getEquityFundsSaga),
    takeLatest(constant.GET_MIXED_FUNDS, getMixedFundsSaga),
    takeLatest(constant.GET_IMMF_FUND, getImmfFundSaga),
  ]);
}
